import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FieldItem } from 'src/app/models/common/field-item';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { AgentService } from '../services/agent.service';

@Component({
  selector: 'sym-agent-party-address',
  templateUrl: './agent-party-address.component.html',
  styleUrls: ['./agent-party-address.component.scss'],
})
export class AgentPartyAddressComponent extends BaseComponent<AgentService> implements OnChanges {
  @Input() model: any;
  protected addressFieldItems: FieldItem[];
  constructor(agentService: AgentService) {
    super(agentService);
  }
  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
  }

  protected pinCode_change(item: FieldItem) {
    // this.service.getCityCd(item);
    // this.service.getStateCd(item);

    if (this.addressFieldItems != undefined) {
      let stateFieldItem: FieldItem;
      let cityFieldItem: FieldItem;
      this.addressFieldItems.filter((addressFieldItem: FieldItem) => {
        if (addressFieldItem.fieldCd == 'stateCd') stateFieldItem = addressFieldItem;
        else if (addressFieldItem.fieldCd == 'cityCd') cityFieldItem = addressFieldItem;
      });
      if (stateFieldItem != undefined) this.service.getStateCd(stateFieldItem);
      if (cityFieldItem != undefined) this.service.getCityCd(cityFieldItem);
    }
  }

  protected pinCode_focus(item: FieldItem) {
    item.model.cityCd = null;
  }

  protected stateCd_focus(item: FieldItem) {
    // if (item.model.pinCode != null && item.model.cityCd != null) {
    //   this.service.getStateCd(item);
    // } else if (item.model.pinCode != null && item.model.cityCd == null) {
    //   this.service.getStateCd(item);
    // }
  }

  public onAddressFieldsCreated(fieldItemArray: FieldItem[]) {
    this.addressFieldItems = fieldItemArray;
  }
}
